import * as React from 'react';
import styled from '@emotion/styled';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDog } from '@fortawesome/free-solid-svg-icons';

export interface EmptyWidgetProps {
  label: string;
}

export const EmptyWidget: React.FC<EmptyWidgetProps> = (props) => {
  return (
    <S.Container>
      <S.Icon icon={faDog} />
      <S.Label>{props.label}</S.Label>
    </S.Container>
  );
};
namespace S {
  export const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 200px;
    row-gap: 20px;
    width: 100%;
  `;

  export const Icon = styled(FontAwesomeIcon)`
    font-size: 50px;
    color: ${(p) => p.theme.text.secondary};
  `;

  export const Label = styled.div`
    color: ${(p) => p.theme.text.primary};
    font-family: Square, sans-serif;
  `;
}
